module.exports = __webpack_public_path__ + "img/icon-group2.70716d1a.png";